import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, AppServerAPI, ContextChange, TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalVisitorRegistration } from '../visitor-registration.model';

@Component({
    selector: 'app-visitor-registration-preparation',
    templateUrl: './visitor-registration-preparation.component.html',
    styleUrls: ['./visitor-registration-preparation.component.scss'],
    standalone: false
})
export class VisitorRegistrationPreparationComponent extends AbstractWidgetComponent implements OnInit {

  preparations: TerminalVisitorRegistration[];

  constructor(
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.appServerAPI.execute<TerminalVisitorRegistration[]>('/terminal/registration/visitor/preparations', {
        identifier: this.dashboardContext.getContextValue('terminalIdentifier')
    }).subscribe(result => {
        this.preparations = result;
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  selectPreparation(preparation: TerminalVisitorRegistration) {
    this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, preparation.registrationId);
    this.dashboardContext.setContextValue(TerminalContextConstants.registrationCode, preparation.registrationCode);
    this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, preparation.numberPlate);
    this.dashboardContext.setContextValue(TerminalContextConstants.lastname, preparation.name);
    this.dashboardContext.setContextValue(TerminalContextConstants.firstname, preparation.firstname);
    this.dashboardContext.setContextValue(TerminalContextConstants.company, preparation.company);
    this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, preparation.gcCaseId);
    this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, preparation.registrationId);
    this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, preparation.reason);
    this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, preparation.visitedPerson);
    this.dashboardContext.setContextValue('needsAreaAccess', preparation.needsAreaAccess);
    this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', preparation.needsAreaAccess);
    this.dashboardContext.setContextValue('visitorType', preparation.visitorType);
    this.dashboardContext.setContextValue('inviteAdditionalVisitorsAllowed', preparation.inviteAdditionalVisitorsAllowed);
    this.dashboardContext.setContextValue('instructionsDone', preparation.instructionsDone);
    this.dashboardContext.setContextValue('inviterId', preparation.inviterId);
    this.dashboardContext.setContextValue('inYard', preparation.inYard);
  }
}
